<template>

  <div class="main main--hasHeader main--hasFooter">
    <div class="customContainer">
      <h2 class="members__headline">{{ word_chg('車両情報') }}</h2>
      <!-- {{ getMyData.cars }} -->
        <div  v-if="Object.keys(cars).length > 0">
          <p style="font-size: 1.3rem;text-align: center;">
            {{ word_chg('走行・来場にお使いになる車両をすべてご登録ください。') }}
          </p>
          <div class="members-carinfo" v-for="(car, index) in cars" :key="car">
            <h3 class="members-carinfo__headline">No.{{ (index + 1) }}</h3>
            <car-photo :images="getCarAssets(index)" v-if="!car.form_disp_sw"></car-photo>
            <p class="members-carinfo__image">
              <!-- {{ car }} -->
              <!-- <img src="@/assets/img/main/members_carinfo_img_01.jpg" alt=""> -->
            </p>
            <div class="mb-3" v-if="car.form_disp_sw && Object.keys(car.assets).length > 0">
              <div class="row">
              <h5 class="mb-2">{{ word_chg('画像一覧') }}</h5>
                <div class="col-3 text-center" v-for="(photo, pi) in car.assets" :key="pi">
                  <img :src="photo.path" class="w-100"><br>
                  <a @click="delPhoto(index, pi)" class="btn btn-warning">{{ word_chg('削除') }}</a>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="container">
                <div class="row">
                  <div class="col">
                    <p class="members-carinfo__btn" v-if="!car.form_disp_sw">
                      <a @click="openForm(index)"  class="button mb-2">{{ word_chg('編集') }}</a>
                      <!--  -->
                    </p>
                    <div class="members-carinfo__btn" style="" v-else>
                      <a @click="closeForm(index)" class="button mb-2">{{ word_chg('閉じる') }}</a>
                    </div>
                  </div>
                </div>
                <div class="row mb-3"  v-if="car.form_disp_sw && Object.keys(car.assets).length <= photo_max">
                  <div class="col-lg-3 col-12 mb-2">{{ word_chg('画像') }}</div>
                  <div class="col-lg-9 col-12">
                    <div class="name members-member-form__data">
                      <input type="file" class="form-control" id="" :name="'image[' + index + ']'" @change="selectedFile(index, $event)">
                    </div>
                  </div>
                </div>
                <div class="members-carinfo__card d-flex mb-3" v-if="!car.form_disp_sw">
                  <ul class="members-carinfo__list">
                    <li class="d-flex align-items-center">
                      <soan class="item">{{ word_chg('ナンバー') }}</soan>
                      <div class="name">
                        <div class="d-inline-block py-2 px-5 bg-white text-center" style="color:#174626;">
                          <span style="font-size:1.5rem;">{{ car.license_plate_area }}</span>
                          <span style="font-size:1.5rem;">{{ car.license_plate_class_number }}</span><br>
                          <span style="font-size:1.5rem;">{{ car.license_plate_kana }}</span>
                          <span style="font-size:2.5rem;">{{ car.license_plate_number }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <h4 class="mb-2" v-if="car.form_disp_sw">{{ word_chg('ナンバー情報') }}</h4>
                <div class="row mb-3"  v-if="car.form_disp_sw">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('運輸支局') }}&nbsp;({{ word_chg('地名') }})</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <div class="name members-member-form__data">
                      <bs-select
                      :options="license_plate_area_list"
                      v-model="car.license_plate_area"
                      :null-option="false"
                      :class-param="'form-select-sm'"
                      :name="'license_plate_area'"
                      ></bs-select>
                    </div>
                  </div>
                </div>
                <div class="row mb-3"  v-if="car.form_disp_sw">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('分類番号') }}&nbsp;({{ word_chg('3桁の数字') }})</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <div class="name members-member-form__data">
                      <input type="text" v-model="car.license_plate_class_number" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="row mb-3"  v-if="car.form_disp_sw">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('かな文字') }}&nbsp;({{ word_chg('かな') }})</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <div class="name members-member-form__data">
                      <input type="text" v-model="car.license_plate_kana" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="row mb-3"  v-if="car.form_disp_sw">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('ナンバー') }}&nbsp;({{ word_chg('4桁の数字') }})</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <div class="name members-member-form__data">
                      <input type="text" v-model="car.license_plate_number" placeholder="">
                    </div>
                  </div>
                </div>
                <h4 class="mb-2">{{ word_chg('車両詳細情報') }}</h4>
                <div class="row mb-3">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('車両タイプ') }}</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <span class="name" v-if="!car.form_disp_sw">{{ word_chg(car_type_label(car.car_type)) }}</span>
                    <div class="name members-member-form__data" v-else>
                      <bs-select
                        :options="car_type_param"
                        v-model="car.car_type"
                        :null-option="false"
                        :class-param="'form-select-sm'"
                        :name="'car_type'"
                        ></bs-select>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('メーカー') }}</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <span class="name" v-if="!car.form_disp_sw">{{ word_chg(car.automaker) }}</span>
                    <div class="name members-member-form__data" v-else>
                    <input type="text" v-model="car.automaker" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('モデル') }}</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <span class="name" v-if="!car.form_disp_sw">{{ word_chg(car.model_number) }}</span>
                    <div class="name members-member-form__data" v-else>
                    <input type="text" v-model="car.model_number" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('年式') }}</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <span class="name" v-if="!car.form_disp_sw">{{ word_chg(car.model_year) }}</span>
                    <div class="name members-member-form__data" v-else>
                    <input type="text" v-model="car.model_year" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('保管') }}</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <span class="name" v-if="!car.form_disp_sw">{{ word_chg(car.strage) }}</span>
                    <div class="name members-member-form__data" v-else>
                      <bs-select
                        :options="strage_list"
                        v-model="car.strage"
                        :null-option="false"
                        :class-param="'form-select-sm'"
                        :name="'strage'"
                        ></bs-select>
                    </div>
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-lg-3 col-12 mb-2">
                    <span class="fs-4">{{ word_chg('備考') }}</span>
                  </div>
                  <div class="col-lg-9 col-12">
                    <span class="name" v-if="!car.form_disp_sw">{{ car.note }}</span>
                    <div class="name members-member-form__data" v-else>
                      <textarea v-model="car.note" placeholder="" class="form-control"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row mb-3" v-if="car.form_disp_sw">
                  <div class="col text-center">
                    <button class="btn btn-warning btn-lg" @click="delCar(index)">
                      No.{{ (index + 1) }}{{ word_chg('の車両情報を削除する') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="members-carinfo__card d-flex1">
              <ul class="members-carinfo__list">
                <!-- <li class="d-flex align-items-center" v-if="car.form_disp_sw && Object.keys(car.assets).length <= photo_max">
                  <soan class="item">{{ word_chg('画像') }}</soan>
                  <div class="name members-member-form__data">
                    <input type="file" class="form-control" id="" :name="'image[' + index + ']'" @change="selectedFile(index, $event)">
                  </div>
                </li>
                <li class="d-flex align-items-center d-none">
                  <soan class="item">{{ word_chg('名称') }}</soan>
                  <span class="name" v-if="!car.form_disp_sw">{{ car.label }}</span>
                  <div class="name members-member-form__data" v-else>
                    <input type="text" v-model="car.label" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="!car.form_disp_sw">
                  <soan class="item">{{ word_chg('ナンバー') }}</soan>
                  <div class="name">
                    <div class="d-inline-block py-2 px-5 bg-white text-center" style="color:#174626;">
                      <span style="font-size:1.5rem;">{{ car.license_plate_area }}</span>
                      <span style="font-size:1.5rem;">{{ car.license_plate_class_number }}</span><br>
                      <span style="font-size:1.5rem;">{{ car.license_plate_kana }}</span>
                      <span style="font-size:2.5rem;">{{ car.license_plate_number }}</span>
                    </div>
                  </div>
                </li>
                <li class="d-flex align-items-center" v-else>
                  <h4>{{ word_chg('ナンバー情報') }}</h4>
                </li>
                <li class="d-flex align-items-center" v-if="car.form_disp_sw">
                  <soan class="item">{{ word_chg('運輸支局') }}<br>({{ word_chg('地名') }})</soan>
                  <div class="name members-member-form__data">
                    <bs-select
                      :options="license_plate_area_list"
                      v-model="car.license_plate_area"
                      :null-option="false"
                      :class-param="'form-select-sm'"
                      :name="'license_plate_area'"
                      ></bs-select>
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="car.form_disp_sw">
                  <soan class="item">{{ word_chg('分類番号') }}<br>({{ word_chg('3桁の数字') }})</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="car.license_plate_class_number" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="car.form_disp_sw">
                  <soan class="item">{{ word_chg('かな文字') }}<br>({{ word_chg('かな') }})</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="car.license_plate_kana" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center mb-4" v-if="car.form_disp_sw">
                  <soan class="item">{{ word_chg('ナンバー') }}<br>({{ word_chg('４桁の数字') }})</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="car.license_plate_number" placeholder="">
                  </div>
                </li> -->

                <!-- <li class="d-flex align-items-center" v-if="car.form_disp_sw">
                  <h4 class="mt-4">{{ word_chg('車両詳細情報') }}</h4>
                </li>
                <li class="d-flex align-items-center">
                  <soan class="item">{{ word_chg('車両タイプ') }}</soan>
                  <span class="name" v-if="!car.form_disp_sw">{{ word_chg(car_type_label(car.car_type)) }}</span>
                  <div class="name members-member-form__data" v-else>
                    <bs-select
                      :options="car_type_param"
                      v-model="car.car_type"
                      :null-option="false"
                      :class-param="'form-select-sm'"
                      :name="'car_type'"
                      ></bs-select>
                  </div>
                </li>
                <li class="d-flex">
                  <soan class="item">{{ word_chg('メーカー') }}</soan>
                  <span class="name" v-if="!car.form_disp_sw">{{ car.automaker }}</span>
                  <div class="name members-member-form__data" v-else>
                    <input type="text" v-model="car.automaker" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center">
                  <soan class="item">{{ word_chg('モデル') }}</soan>
                  <span class="name" v-if="!car.form_disp_sw">{{ car.model_number }}</span>
                  <div class="name members-member-form__data" v-else>
                    <input type="text" v-model="car.model_number" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center">
                  <soan class="item">{{ word_chg('年式') }}</soan>
                  <span class="name" v-if="!car.form_disp_sw">{{ car.model_year }}</span>
                  <div class="name members-member-form__data" v-else>
                    <input type="text" v-model="car.model_year" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center">
                  <soan class="item">{{ word_chg('保管') }}</soan>
                  <span class="name" v-if="!car.form_disp_sw">{{ word_chg(car.strage) }}</span>
                  <div class="name members-member-form__data" v-else>
                    <bs-select
                      :options="strage_list"
                      v-model="car.strage"
                      :null-option="false"
                      :class-param="'form-select-sm'"
                      :name="'strage'"
                      ></bs-select>
                  </div>
                </li>
                <li class="d-flex align-items-center">
                  <soan class="item">{{ word_chg('備考') }}</soan>
                  <span class="name" v-if="!car.form_disp_sw">{{ car.note }}</span>
                  <div class="name members-member-form__data" v-else>
                    <textarea v-model="car.note" placeholder="" class="form-control"></textarea>
                  </div>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
        <div v-else>
          {{ word_chg('走行・来場にお使いになる車両をすべてご登録ください。') }}
        </div>
        <div v-if="Object.keys(cars).length < max" class="members-carinfo">
          <p class="reserve05__addMember py-3">
              <a class="reserve05__addMemberLink" @click="addCar()">＋ {{ word_chg('車両を追加登録する。') }}</a>
          </p>
        </div>
        <div v-else class="members-carinfo">
          <p>{{ word_chg('登録できる車両数は') }}{{max }}{{ word_chg('台までです。') }}</p>
        </div>
        <div v-if="Object.keys(cars).length > 0" class="members-carinfo my-3">
          <p class="members-carinfo__add"><a class="button" @click="confirm">{{ word_chg('登録') }}</a></p>
        </div>
    </div>
  </div>
</template>
<script>
import config from '../../../const'
import { mapState } from 'vuex'
// import BsPageTitle from '../../molecules/BsPageTitle.vue'
// import CardView from './CardView.vue'
import axios from 'axios'

import CarPhoto from './CarPhotoView.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import '../../assets/bootstrap/css/sc.css';

export default {
  name: 'UserCarView',
  data: function () {
      return {
        edit_mode: false,
        max: 15,
        photo_max: 4,
        carFrm: {
          label: '',
          license_plate_number: '',
          automaker: '',
          model_name: '',
          model_number: '',
          model_year: '',
          form_disp_sw: true,
          note: '',
          assets: [],
        },
        cars: [
        ],
        car_type_default_param: {},
        // uploadFile: [],
      }
  },
  components: {
    CarPhoto,
    BsSelect
  },
  methods: {
    loadLedgerType(){
        const params = {};
        params['stat'] = 1;
        params['type'] = 'drive';
        return this.$store.dispatch('fetchBasicLists', {data: params, target: 'ledger_type'})
                    .catch(err => Promise.reject(err))
                    .then(() => {
                    })
                    .finally(() => {
                    })

        },
    selectedFile: function(index, e) {
      e.preventDefault();
      const files = [...e.target.files];
      // let ups = [];
      console.log('selectedFile', index, typeof(files),  files);
      files.forEach(file => {
        const form = new FormData();
        form.append('file', file);
        axios.post(
          config.BASE_API_URL + '/upload/car',
          form,
          {
            headers: this.axiosHeader
          }
        )
        .then(res => {
          console.log(res);
          if(res && res.status == 200){
            const sortNum = (typeof this.cars[index].assets === 'object')? Object.keys(this.cars[index].assets).length: 0;
            const asset = {
              id: 0,
              stat: 1,
              car_id: this.cars[index].id,
              sort: sortNum + 1,
              label: '',
              path: (res.data.body.file_path)? res.data.body.file_path: '',
            }
            this.cars[index].assets.push(asset);
            // ups.push(res.data.body);
          }
        })
        .catch(error => {
          console.log(error);
        });
      });

    },
    delPhoto(index, photo_index){
      const carphotos = this.cars[index].assets;
      carphotos.splice(photo_index, 1);
      this.cars[index].assets = carphotos;
    },
    delCar(target){
      if(
        window.confirm('削除しますか？')
      ){
        const tmp = this.cars;
        console.log('delCar tmp =', tmp);
        tmp.splice(target, 1);
        console.log('delCar tmp.splice =', tmp);
        this.cars = tmp;
        console.log('delCar cars =', this.cars);
        this.update();

      }
    },
    addCar(){
      const tmp = {};
      Object.assign(tmp, this.carFrm);
      this.cars.push(tmp);
    },
    openForm(target){
      const tmp = this.cars;
      tmp[target].form_disp_sw = true;
      this.cars = tmp;
    },
    closeForm(target){
      const tmp = this.cars;
      tmp[target].form_disp_sw = false;
      console.log('delGuest tmp =', tmp);
      console.log('delGuest tmp.splice =', tmp);
      this.cars = tmp;
      console.log('delGuest guestFrm =', this.cars);
    },
    confirm(){
      let check = true;
      const msg = [];
      if(Object.keys(this.cars).length > 0){
        Object.keys(this.cars).forEach(key => {
          // const carNum = (key + 1);
          // model_number 
          if(this.cars[key].model_number == ''){
            check = false;
            const msg_tgt = this.word_chg('モデル');
            const pre_tgt = this.word_chg('入力msg_Pre');
            const post_tgt = this.word_chg('入力msg_Post');
            msg.push(pre_tgt + msg_tgt + post_tgt);
            // msg.push('No.' + carNum + this.word_chg('のモデルを入力してください。'));
          }
          // automaker
          if(this.cars[key].automaker == ''){
            check = false;
            const msg_tgt = this.word_chg('メーカー');
            const pre_tgt = this.word_chg('入力msg_Pre');
            const post_tgt = this.word_chg('入力msg_Post');
            msg.push(pre_tgt + msg_tgt + post_tgt);
            // msg.push('No.' + carNum + this.word_chg('のメーカーを入力してください。'));
          }
        })
      }
      else{
        check = false;
        msg.push(this.word_chg('車両を追加してください。'));
      }
      if(check){
        this.update();
      }
      else{
        const message = msg.join('\n');
        alert(message);
      }
    },
    update(){
      // alert('登録しました-demo-');
      const mydata = this.getMyData;
      delete mydata['login_pass'];
      mydata['car_data'] = this.cars;
      console.log('component methods', mydata);
      return this.$store.dispatch('updateBasic', {data: mydata, target: 'member' })
          .then(() => {
            // // this.back()
            alert(this.word_chg('更新しました。'));
            // this.alertMessage = this.btnLabel + 'しました';
            // this.alertClass = 'alert-success';
          })
          .catch(
            () => {
            err => Promise.reject(err);
            alert(this.word_chg('更新できませんでした。'));
              // this.alertMessage = this.btnLabel + 'できませんでした';
              // this.alertClass = 'alert-danger';
            }
          )
          .finally(() => {
            this.loadUser();
          })
    },
    // login御
    loadUser(){
      const params = {};
      params['id'] = this.$store.state.auth.userId;
      console.log('params', params);
      return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
      .catch((err) => {
        console.log(err);
        Promise.reject(err)
      })
      .then(() => {})
      .finally(() => {
        this.$forceUpdate();
      });
    },
    loadLicensePlateArea(){
      const params = {};
      return this.$store.dispatch('fetchBasicLists', {data: params, target: 'license_plate_area'})
      .catch((err) => {
        console.log(err);
        Promise.reject(err)
      })
      .then(() => {})
      .finally(() => {});

    },
  },
  computed: {
    ...mapState({
      user: state => state.apidata.user,
      license_plate_area_list: state => state.apidata.license_plate_area,
      ledger_type: state => state.apidata.ledger_type,
    }),

    car_type_param: function(){
      const tmps = [];
      const car_type = this.ledger_type.find(type => type.id == 8);
      if(typeof car_type === 'object' && typeof car_type.default_param === 'object'){
        Object.values(car_type.default_param).forEach(param => {
          tmps.push({
            key: param.id,
            label: this.word_chg(param.label)
          });
        })
      }
      return tmps;
    },
    car_type_label: function(){
      const params = this.car_type_param;
      return function(type) {
        if(params.find(param => param.key == type)){
          const p = params.find(param => param.key == type);
          return p.label;
        }else{
          return '未指定';
        }
      }
    },
    strage_list: function(){
      const tmp = [
        {
          key: '自走持込車',
          label: this.word_chg('自走持込車')
        },
        {
          key: 'オーナーズガレージ保管車',
          label: this.word_chg('オーナーズガレージ保管車')
        }
      ];
      return tmp;
    },
    getCarAssets: function(){
      const cars = this.cars;
      return function(index){
        const assets_files = [];
        if(cars[index] && cars[index].assets){
          Object.values(cars[index].assets).forEach(asset => {
            assets_files.push(asset.path);
          });
        }
        return assets_files;
      }
    },
    getMyCars: function(){
      if(this.getMyData.cars){
        return this.getMyData.cars;
      }
      return [];
    },
    getMyData: function(){
      const mydata = this.user.find((data) => {
        return data.id == this.$store.state.auth.userId;
      })
      return mydata;
    },
    axiosHeader: function(){
        return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
    },
  },
  created () {
    this.loadUser();
    this.loadLicensePlateArea();
    this.loadLedgerType();
    this.cars = this.getMyCars.map(car => {
      car.form_disp_sw = false;
      return car;
    });
  },
  mounted: function(){
  },

  props: {
  }

}
</script>
